<template>
  <div>
    <RankUsersComponent
      v-for="rank in ranks"
      :key="rank.name"
      :title="rank.title"
      :api="rank.api"
      :name="rank.name"
      :list-url="rank.listUrl"
    />
  </div>
</template>

<script>
  import RankUsersComponent from '../components/RankUsersComponent'
  import i18n from '@/i18n'

  const ranks = [
    {
      title: i18n.t('rank.news', [i18n.t('date.today')]),
      listUrl: '/rank/n/today',
      api: '/news/ranks?type=day&limit=15',
      name: 'rankNewsToday',
    },
    {
      title: i18n.t('rank.answer', [i18n.t('date.week')]),
      listUrl: '/rank/n/week',
      api: '/news/ranks?type=week&limit=15',
      name: 'rankNewsWeek',
    },
    {
      title: i18n.t('rank.answer', [i18n.t('date.month')]),
      listUrl: '/rank/n/month',
      api: '/news/ranks?type=month&limit=15',
      name: 'rankNewsMonth',
    },
  ]

  export default {
    name: 'RankNews',
    components: {
      RankUsersComponent,
    },
    data () {
      return {
        ranks,
      }
    },
  }
</script>
